import {Component, Input, OnInit} from '@angular/core';
import { DatePipe } from '@angular/common';
import { ToastService } from '../../../services/toast.service';
import { Contrato } from '../../../types/Contrato.type';
import { Instancia } from '../../../types/Instancia.type';
import {ContratoService} from "../../../services/contrato.service";
import {ConfirmationService} from "primeng/api";

@Component({
  selector: 'app-contratos',
  templateUrl: './contratos.component.html',
  styleUrl: './contratos.component.css',
  providers: [ConfirmationService, DatePipe],
})
export class ContratosComponent implements OnInit {

  @Input() statusContrato: string = '';
  @Input() habilitaBusca: boolean = false;
  @Input() habilitaIntegracao: boolean = true;
  @Input() habilitaExportacao: boolean = true;
  @Input() habilitaCancelamento: boolean = false;
  @Input() habilitaData: boolean = false;
  @Input() operacao: string = '';

  totalRecords: number = 0;
  loading: boolean = false;
  termo: string = '';
  contratoDialog: boolean = false;
  contratoSelecionado: Contrato = {} as Contrato;
  loadingSincronizar: boolean = false;
  contratosSelecionados: Contrato[] = [];
  dataBaixa?: Date;

  contratos: Contrato[] = [];

  constructor(
    private contratoService: ContratoService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
  ) {
    this.onInstanciaChange({
      first: 0,
      rows: 10,
      sortField: 'cdEmpresaErp',
      sortOrder: 1,
    });
  }

  ngOnInit() {}

  instancias: Instancia[] = [
    { id: 'VALE', nome: 'VALE' },
    { id: 'UCP', nome: 'UCP' },
    { id: 'UVP', nome: 'UVP' },
  ];
  instanciaSelecionada!: string;

  status: any[] = [ {name: 'Integrado', value: 'Integrado' }
    , {name: 'Folha', value: 'Folha'}
    , {name: 'Cancelado', value: 'Cancelado'}
    , {name: 'Pendente Cancelamento', value: 'Pendente Cancelamento'}
    , {name: 'Atualizar', value: 'Atualizar'}
    , {name: 'Não integrado', value: 'Não integrado'}
    , {name: 'Novo', value: 'Novo'}
    , {name: 'Erro', value: 'Erro'}
  ]

  limpaSelecionados() {
    this.contratosSelecionados = []
  }

  onInstanciaChange(event: any) {
    this.loading = true;
    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';

    this.termo =
      event.globalFilter === undefined && this.termo
        ? this.termo
        : event.globalFilter;

    console.log(event.globalFilter);

    this.getContratos(event.first, event.rows, event.sortField, sortDirection, this.instanciaSelecionada, this.termo, this.statusContrato);


  }

  getContratos(first: number, rows: number, sortField: string, sortDirection: string, instancia: string, termo: string, statusContrato: string) {

    this.contratoService
      .getContratos(
        first / rows,
        rows,
        sortField,
        sortDirection,
        instancia,
        termo || '',
        statusContrato
      )
      .subscribe({
        next: (data) => {
          this.contratos = data;
          this.totalRecords = data.length;
        },
        complete: () => {
          this.loading = false;
          this.limpaSelecionados()
        },
      });
  }

  onRowSelect(event: any) {
    console.log(event);

    if (event.type == 'row') {
      this.contratoDialog = true;
      this.contratoSelecionado = event.data;

      this.contratoService
        .getContrato(
          this.contratoSelecionado.instancia,
          this.contratoSelecionado.idContrato
        )
        .subscribe({
          next: (data) => {
            this.contratoSelecionado = data;
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro ao abrir o contrato: ' + err.message
            );
          },
        });
    }
  }

  exibeContrato(contrato: Contrato) {
    console.log(event);

      this.contratoDialog = true;
      this.contratoSelecionado = contrato

      this.contratoService
        .getContrato(
          this.contratoSelecionado.instancia,
          this.contratoSelecionado.idContrato
        )
        .subscribe({
          next: (data) => {
            this.contratoSelecionado = data;
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro ao abrir o contrato: ' + err.message
            );
          },
        });

  }

  escondeDialog() {
    this.contratoDialog = false;
  }

  buscarContratos() {
    this.loading = true
    this.loadingSincronizar = true

    this.contratoService
        .buscaContratos(
          localStorage.getItem("cdUsuarioErp")
        )
        .subscribe({
          next: (data) => {
            this.toastService.info("Sucesso", "Busca realizada");
            this.loading = false
            this.loadingSincronizar = false
            this.limpaSelecionados()
          },
          error: (err) => {
            console.log(err)
            this.toastService.erro(
              'Erro',
              err.error
            );
            this.loading = false
            this.loadingSincronizar = false
          }
        });
  }

  integrar(){
    this.loading = true;
  this.loadingSincronizar = true;

  let corpo = {
    contratos: this.contratosSelecionados.map(p => { return {instancia: p.instancia, contrato: p.idContrato}}),
    usuario: localStorage.getItem("cdUsuarioErp")
  }

  this.contratoService.postEnviarContratos(corpo, this.operacao).subscribe({
    next: (value) => {
        this.toastService.alerta("Finalizado", "Processo finalizado")
    },
    error: (erro) => {
      this.toastService.erro("Erro", "Erro: " + erro.error);
      this.loading = false;
      this.loadingSincronizar = false
    },
    complete: () => {
      this.loading = false;
      this.loadingSincronizar = false
    }
  })
  }

  exportar(){

    if(this.contratosSelecionados.length == 0){
      this.toastService.info("","Necessário selecionar os registros à serem exportados")

    }else{
      let corpo = {
        contratos: this.contratosSelecionados.map(p => { return {instancia: p.instancia, contrato: p.idContrato}}),
        usuario: localStorage.getItem("cdUsuarioErp")
      }

      this.contratoService.exportarContratos(corpo).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a')
        a.href = url
        a.download = 'data.xlsx'
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
    }
  }

  cancelar(){
    if(this.contratosSelecionados.length == 0){
      this.toastService.info("","Necessário selecionar os registros à serem exportados")

    }else if(this.habilitaData && !this.dataBaixa){
      this.toastService.info("","Necessário preencher a data de baixa")

    }else{
      let corpo = {
        contratos: this.contratosSelecionados.map(p => { return {instancia: p.instancia, contrato: p.idContrato}}),
        usuario: localStorage.getItem("cdUsuarioErp")
      }

      const dataBaixaFormatada = this.dataBaixa ? this.datePipe.transform(this.dataBaixa, 'yyyy-MM-dd') ?? undefined : undefined;
      const mensagemData = dataBaixaFormatada ? ` com data de baixa ${this.datePipe.transform(this.dataBaixa, 'dd/MM/yyyy')}` : '';

      this.confirmationService.confirm({
        message: `Tem certeza que deseja cancelar os itens selecionados${mensagemData}? Essa operação é irreversível`,
        header: 'Confirmar',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        acceptButtonStyleClass: 'bg-red-500',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {
          this.contratoService.cancelar(corpo, dataBaixaFormatada).subscribe({
            next: (value) => {
              this.toastService.alerta("Finalizado", "Contrato(s) cancelado(s) com sucesso")
              this.contratosSelecionados = []

            },
            error: (erro) => {
              this.toastService.erro("Erro", "Erro: " + erro.error);
            },
            complete: () => {
              this.loading = false;
              this.loadingSincronizar = false
            }
          });
        },
      });

    }
  }
}
